import React, { useState, useEffect } from "react";
import {
  MapContainer,
  TileLayer,
  useMap,
  Marker,
  Popup,
  GeoJSON,
  Polygon,
  Tooltip,
} from "react-leaflet";
import "leaflet/dist/leaflet.css";
import villageBorder from "../../Grafik/villageBorder";
import apiService from "apiService";

const center = [-7.691711, 110.390204];

const MapTb = ({ data, tahun }) => {
  const [map, setmap] = useState(null);
  const [village, setvillage] = useState([]);
  const [poly, setpoly] = useState([]);
  const [dusun, setdusun] = useState([]);
  const [coba, setcoba] = useState([]);

  function onEachFeature(feature, layer) {
    // does this feature have a property named popupContent?
    if (feature.properties && feature.properties.popupContent) {
      layer.bindPopup(feature.properties.popupContent);
    }
  }

  useEffect(() => {
    if (data.length > 0) {
      generatePolyline();
      getDusun();
    }
  }, [village, tahun]);

  const array_move = (arr, old_index, new_index) => {
    if (new_index >= arr.length) {
      var k = new_index - arr.length + 1;
      while (k--) {
        arr.push(undefined);
      }
    }
    arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
    return arr; // for testing
  };
  const clearMap = () => {
    const m = map;
    for (i in m._layers) {
      if (m._layers[i]._path != undefined) {
        try {
          m.removeLayer(m._layers[i]);
        } catch (e) {
          console.log("problem with " + e + m._layers[i]);
        }
      }
    }
  };
  const getDusun = async () => {
    clearMap();
    const res = await apiService.get("demograph/dusun");
    if (res.code == 200) {
      let dat = res.data;
      for (let i = 0; i < dat.length; i++) {
        let newLatLong = [];
        let element = dat[i];
        element.boundaries = JSON.parse(element.boundaries);
        for (let j = 0; j < element.boundaries[0].length; j++) {
          let el = element.boundaries[0][j];
          newLatLong.push(array_move(el, 0, 1));
        }
        dat[i].boundaries = newLatLong;
      }
      setdusun(dat);
    } else {
      setdusun([]);
    }
  };

  const generatePolyline = () => {
    let pol = [];
    if (data.length > 0) {
      village.map((a, k) => {
        let x = data.find(
          (e) =>
            e.display.toLowerCase().split(" ").join("") ==
            a.village.toLowerCase().split(" ").join("")
        );
        if (x) {
          pol.push(
            <Polygon
              key={k + 1}
              pathOptions={{
                color: "black",
                stroke: true,
                weight: 1,
                fillOpacity: 0,
              }}
              positions={a.border}
            >
              <Tooltip sticky>
                <div>
                  <div>{a.village}</div>
                  <div>Screening : {x ? x.screening : 0}</div>
                  <div>Terduga : {x ? x.terduga : 0}</div>
                  <div>Kasus : {x ? x.kasus : 0}</div>
                </div>
              </Tooltip>
            </Polygon>
          );
        }
      });
    }
    setpoly(pol);
  };
  useEffect(() => {
    if (map) {
      map.target._onResize();
      let dat = villageBorder.filter((e) => e.district == "SLEMAN");
      if (dat) {
        for (let i = 0; i < dat.length; i++) {
          let newLatLong = [];
          const element = dat[i];
          for (let j = 0; j < element.border.length; j++) {
            const el = element.border[j];
            newLatLong.push(array_move(el, 0, 1));
          }
          // L.polygon(newLatLong, {
          //   color: "black",
          //   stroke: true,
          //   weight: 0.3,
          //   fillOpacity: 0,
          // }).addTo(map.target);
          dat[i].border = newLatLong;
        }
      }
      setvillage(dat);
    }
  }, [map]);

  const polygon = [
    [-7.7578, 110.3325],
    [-7.7576, 110.3323],
    [-7.7574, 110.3322],
    [-7.7571, 110.3321],
  ];
  return (
    <MapContainer
      id="kunjungan"
      center={center}
      style={{ width: "100%", height: "58vh" }}
      zoom={11}
      whenReady={setmap}
    >
      <TileLayer
        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
      />
      {/* <GeoJSON
        key={0}
        data={Prov.features[0]}
        pathOptions={{ color: "black", stroke: true, fillOpacity: 0}}
      /> */}
      {console.log(dusun, "dusun")}
      {dusun.map((a, k) => (
        <Polygon
          key={k + 1}
          pathOptions={{
            color: "black",
            stroke: true,
            weight: 0.5,
            fillOpacity: 0,
          }}
          positions={a.boundaries}
        >
          <Tooltip sticky>{a.name}</Tooltip>
        </Polygon>
      ))}
      {/* {poly} */}
    </MapContainer>
  );
};

export default MapTb;
